import { useState } from 'react';
import { AIIcon, PreloaderIcon } from '../../../../../common/ui/icons';
import { fixTodoProblemWithGroqAI } from '../../../data/planner-data-service';
import { usePlannerStore } from '../../../data/planner-store';
import { showToast } from '../../../../../common/domain/toast-provider';
import { combineProjectData } from '../../../domain/planner-provider';
import { sendCloseActionsEvent } from '../../../../../common/ui/actions';

interface IGroqFixProblemButton {
    todo_id: number|string;
}

const GroqFixProblemButton = ({ todo_id }: IGroqFixProblemButton) => {

    const setCombinedProject = usePlannerStore(state => state.setCombinedProject);

    const [isLoading, setIsLoading] = useState(false);

    const onClick = async () => {

        setIsLoading(true);

        const response = await fixTodoProblemWithGroqAI(todo_id);

        setIsLoading(false);

        if(!response) {
            showToast('An error has occurred.');
            return;
        }

        setCombinedProject(combineProjectData(response));

        showToast('Ready.', false);

        sendCloseActionsEvent();
    };

    return (
        <div>
            {
                isLoading &&
                <div
                    className="todo__groq-fix-problem-btn flex bg-indigo-100 rounded mx-1 justify-center items-center action-btn">
                    <PreloaderIcon size={ 20 } color={ '#717985' }/>
                </div>
            }

            {
                !isLoading &&
                <button
                    type="button"
                    className="todo__groq-fix-problem-btn flex bg-indigo-100 rounded mx-1 justify-center items-center action-btn"
                    rel="noreferrer"
                    onClick={ onClick }
                    title="Fix Problem with AI Groq">
                    <AIIcon color={ '#586180' }/>
                </button>
            }
        </div>
    )
};

export default GroqFixProblemButton;